import SparkMD5 from 'spark-md5'

export default function md5(object: any) {

  if (!(object instanceof Blob)) {
    const hexHash = SparkMD5.hash(object)
    return Promise.resolve(hexHash)
  }



  return new Promise(function (resolve, reject) {
    const blob: Blob = object
    const spark = new SparkMD5()
    const reader = new FileReader()
    const chunkSize = 1024 * 1024 * 2  // Read in chunks of 1kb
    const chunks = Math.ceil(blob.size / chunkSize)
    let currentChunk = 0


    reader.onload = function (e: any) {
      spark.append(e.target.result)
      currentChunk++

      if (currentChunk < chunks) {
        loadNext()
      } else {
        const hexHash = spark.end()
        
        console.info('computed hash', hexHash)  // Compute hash
        resolve(hexHash)
      }
    }

    reader.onerror = function (e) {
      reject(e)
    }


    function loadNext() {
      let start = currentChunk * chunkSize
      let end = ((start + chunkSize) >= blob.size) ? blob.size : start + chunkSize

      reader.readAsText(blob.slice(start, end))
    }

    loadNext()

  })

}